// Built-ins
import React, { useEffect, useState } from "react";

// Modules
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

// CSS
import "react-tabs/style/react-tabs.css";

// Custom Made Components
import NavigationBar from "../../core/navigation_bar/navigation_bar";
import Footer from "../../core/footer/footer";
import ProjectOverview from "./project_overview/project_overview";
import RelatedObjects from "./related_objects/related_objects";
import Tasks from "./tasks/tasks";
import Appointments from "./appointments/appointments";
import {
  PROJECT_TAB_KEYS,
  projectIdFromPath,
  rememberProjectWorkspace,
  replaceTabInUrl,
  tabIndexFromSearch,
} from "../../common/projectWorkspace";

function Project() {
  const projectId = projectIdFromPath();
  const [tabIndex, setTabIndex] = useState(() => tabIndexFromSearch(PROJECT_TAB_KEYS));

  useEffect(() => {
    rememberProjectWorkspace({
      projectId,
      tab: PROJECT_TAB_KEYS[tabIndex] || PROJECT_TAB_KEYS[0],
    });
  }, [projectId, tabIndex]);

  const onSelect = (index) => {
    setTabIndex(index);
    replaceTabInUrl(PROJECT_TAB_KEYS, index);
    rememberProjectWorkspace({
      projectId,
      tab: PROJECT_TAB_KEYS[index] || PROJECT_TAB_KEYS[0],
    });
  };

  return (
    <div>
      <NavigationBar />
      <Tabs selectedIndex={tabIndex} onSelect={onSelect}>
        <TabList>
          <Tab>Overview</Tab>
          <Tab>Clients</Tab>
          <Tab>Documents</Tab>
          <Tab>Client contacts</Tab>
          <Tab>Properties</Tab>
          <Tab>Bank project accounts</Tab>
          <Tab>Tasks</Tab>
          <Tab>Appointments</Tab>
          <Tab>Accounting</Tab>
        </TabList>
        <TabPanel>
          <ProjectOverview />
        </TabPanel>
        <TabPanel>
          <RelatedObjects section="clients" />
        </TabPanel>
        <TabPanel>
          <RelatedObjects section="documents" />
        </TabPanel>
        <TabPanel>
          <RelatedObjects section="client_contacts" />
        </TabPanel>
        <TabPanel>
          <RelatedObjects section="properties" />
        </TabPanel>
        <TabPanel>
          <RelatedObjects section="bank_project_accounts" />
        </TabPanel>
        <TabPanel>
          <Tasks />
        </TabPanel>
        <TabPanel>
          <Appointments />
        </TabPanel>
        <TabPanel>
          <RelatedObjects section="cash" />
        </TabPanel>
      </Tabs>
      <Footer />
    </div>
  );
}

export default Project;
